import { useEffect, useRef } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';

import { appEvents } from '@/services/appEvents';

import type { MapView } from '@/services/appEvents';

/** Routes that render the map screen, and so its Insights story when `?view=story`. */
const STORY_ROUTES = ['/map', '/sites', '/updates'];

/** `?view=story` on a map route is Insights; bare `/map` is Maps. */
export function mapViewFrom(pathname: string, searchParams: URLSearchParams): MapView {
  if (searchParams.get('view') === 'story' && STORY_ROUTES.includes(pathname)) return 'story';
  return pathname === '/map' ? 'maps' : 'other';
}

/** Emits `view.changed`, derived once from the URL rather than at each `?view` writer. */
export function useViewChangeEvents() {
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();
  const view = mapViewFrom(pathname, searchParams);
  const previous = useRef(view);

  useEffect(() => {
    if (previous.current === view) return;
    const from = previous.current;
    previous.current = view;
    appEvents.emit('view.changed', { from, to: view });
  }, [view]);
}
